import React from 'react';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { CreateReportsPage } from 'src/components/enterprise/features/Reporting/CreateReportsPage/CreateReportsPage';
import { ManageReportsPage } from 'src/components/enterprise/features/Reporting/ManageReportsPage/ManageReportsPage';

const CreateReportsPageLayout = withEnterpriseLayout(CreateReportsPage);
const ManageReportsPageLayout = withEnterpriseLayout(ManageReportsPage);

export const ReportingCreateRoute = (): JSX.Element => (
  <CreateReportsPageLayout pageTitle="Create Reports" />
);

export const ReportingManageRoute = (): JSX.Element => (
  <ManageReportsPageLayout pageTitle="Reports | Manage" />
);
